import React from 'react';
import { useState, useEffect } from 'react' 
import { Link } from 'react-router-dom';
import { db } from '../../../../firebase';
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot } from 'firebase/firestore';

const FaceBook = ({portfolioData}) => {   
    return (
        <>
            {/* <div className="page-hd clearfix">
                <div className="left-float" style={{marginTop: "0px", marginRight: "20px"}}>
                    <img src="/images/skin1/fb-logo.png" /> 
                </div>
                <div className="left-float" style={{marginTop: "10px"}}>
                    <p><strong>Experience: 3 Years</strong></p>
                    <p><strong></strong></p>
                </div>
            </div> */}
            <h1>Facebook</h1>
            <ul>
                <li>Over 3+ years of experience in Designing, Implementing and Optmizing targeted Ads using FaceBook digital marketing campaign.
                </li>
                <li>Overhauled the digital marketing strategy to rebrand the product in the market.</li> 
                <li>Created A/B Marketing campaigns to analyze the strategies leading to an improvement of user onboarding by 200%</li> 
            </ul>
            {/* <h3>Below are examples of FB Ad campaigns</h3><hr />
            <div className="flex-item card link">
                <div>
                    <div className="card-tn">
                        <img src="/images/skin1/images/FB-Ad-01.png" /> 
                    </div>
                    <div className="card-content">
                        <p className="txt-18 thickest">
                         
                        </p>
                    </div>
                </div>
            </div> */}
           {/*  <div className="flex-item card link">
                <div>
                    <div className="card-tn">
                        <img src="/images/skin1/images/FB-Ad-02.png" /> 
                    </div>
                    <div className="card-content">
                        <p className="txt-18 thickest">
                         
                        </p>
                    </div>
                </div>
            </div> */}
        </>
        
    )

}
export default FaceBook;